import MyPrivacyChoices from "../components/MyPrivacyChoices";

function MyPrivacyChoicesPage() {
  return <MyPrivacyChoices />;
}
export default MyPrivacyChoicesPage;
